import { Fragment, useState, useEffect, useRef } from 'react'
import { Button, ButtonGroup, Card, CardBody, Col, Container, InputGroup, Row } from 'reactstrap'
import CardHeaderSpan from '../../../Utils/CommonComponents/CardHeaderSpan'
import { AttendanceListTitle, AttendanceTitle } from '../../../Utils/Constants'
import AttendanceList from './AttendanceList'
import AttendanceTable from './AttendanceTable'
import { ButtonColor } from '../../../Types/ButtonsType'
import { Btn, H3 } from '../../../AbstractElements'
import HumanFriendlyDatePicker from '../../Forms/FormWidgets/Datepicker/DatePicker/HumanFriendlyDatePicker'
import DatePicker from 'react-datepicker'
import CommonModal from '../../../CommonElements/Functions/CommonModels'
import UserListPage from '../../../CommonElements/Mock/UserListPage'
import { useNavigate, useLocation } from 'react-router-dom';
import { Calendar } from 'react-feather';
import 'react-datepicker/dist/react-datepicker.css';

export default function AttendanceContainer() {
    const location = useLocation();
    const navigate = useNavigate();

    const queryParams = new URLSearchParams(location.search);
    const dateParam = queryParams.get('date');

    const [startDate, setStartDate] = useState<Date | null>(
        dateParam ? new Date(dateParam) : new Date() // fallback to today if not present
    );
    const datePickerRef = useRef<any>(null);

    const handleContainerClick = () => {
        if (datePickerRef.current) {
            datePickerRef.current.setFocus(); // Opens calendar
        }
    };
    const handleChange = (date: Date | null) => {
        if (date) {
            setStartDate(date);

            const newParams = new URLSearchParams(location.search);
            newParams.set('date', date.toISOString().split('T')[0]);

            navigate({ search: newParams.toString() }, { replace: true });
        }
    };

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col sm={12} className='p-2'>
                        <Card>
                            <div className='d-flex justify-content-between align-items-center '>
                                <CardHeaderSpan headingClassName='pb-0' back={false} heading={AttendanceTitle} span={AttendanceListTitle} />
                            <div className="p-3">
                                <div
                                    // onClick={handleContainerClick}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        width: '180px',
                                        border: 'none',
                                        borderRadius: '5px',
                                        padding: '4px 5px',
                                        // cursor: 'pointer',
                                    }}
                                    className='bg-primary'
                                >
                                    <Calendar size={20} color="#fff" />
                                    <DatePicker
                                        selected={startDate}
                                        onChange={handleChange}
                                        maxDate={new Date()}
                                        dateFormat="MMMM dd, yyyy"
                                        className="form-control border-0 p-0 text-light"
                                        wrapperClassName="w-100"
                                        ref={datePickerRef}
                                    />
                                </div>
                            </div>
                            </div>


                            <CardBody>
                                {/* <UserListPage/> */}
                                {/* <AttendanceList /> */}
                                <AttendanceTable startDate={startDate?.toISOString().split('T')[0] || ''} />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
